<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconStopRound_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM5.9 5.2a.7.7 0 0 0-.7.7v4.2a.7.7 0 0 0 .7.7h4.2a.7.7 0 0 0 .7-.7V5.9a.7.7 0 0 0-.7-.7H5.9Z"
        clip-rule="evenodd"
    />
</svg>
